var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputChoiceSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 44,
    viewBox: "0 0 120 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 44,
    fill: "#FFF",
    rx: 0.592
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.201,
    d: "M10 6c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5zm0 9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zM20 8h93v6H20z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 22h120v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    fillOpacity: 0.201,
    d: "M10 28c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5zm0 9c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zM20 30h74v6H20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputChoiceSet);
export default __webpack_public_path__ + "static/media/inputChoiceSet.3361973ead499760f8d64ccdd5c62cd1.svg";
export { ForwardRef as ReactComponent };